import { FormattedMessage } from 'react-intl';
import Link from '~/jobiqo/components/Link';
import { Main } from '~/vcl/atoms/06-layout/09-main';
import { Box } from '~/vcl/atoms/07-box';
import { Tab, TabList, Tabs } from '~/vcl/atoms/17-tabs';
import { TabLink } from '~/vcl/atoms/17-tabs/01-tab-link';
import styles from '../miniSite.module.scss';
import type { OrganizationMiniSiteTabsProps } from './types';
import { getMiniSiteMenuTabValue } from './utils';

export const OrganizationMiniSiteTabs = ({
  activeTab,
  homePath,
  jobsPath,
  menuItems = [],
}: OrganizationMiniSiteTabsProps) => (
  <div className={styles.tabsBar}>
    <Main size="xLarge">
      <Tabs
        hardBackground={false}
        tabEqualSpace={false}
        tabsListItemFull={true}
        value={activeTab}
      >
        <div className={styles.tabsInset}>
          <Box padding={0} marginClean={true} boxShadow="none" borderRadius="0">
            <TabList>
              <Tab asChild={true} value="menu">
                <TabLink
                  href={homePath}
                  linkElement={Link}
                  selected={activeTab === 'menu'}
                >
                  <FormattedMessage
                    id="mini_site_tab_default"
                    defaultMessage="Home"
                  />
                </TabLink>
              </Tab>
              <Tab asChild={true} value="jobs">
                <TabLink
                  href={jobsPath}
                  linkElement={Link}
                  selected={activeTab === 'jobs'}
                >
                  <FormattedMessage
                    id="mini_site_tab_jobs"
                    defaultMessage="Jobs"
                  />
                </TabLink>
              </Tab>
              {menuItems.map((menuItem) => {
                const tabValue = getMiniSiteMenuTabValue(menuItem.path);

                return (
                  <Tab
                    asChild={true}
                    key={menuItem.id ?? menuItem.path}
                    value={tabValue}
                  >
                    <TabLink
                      href={menuItem.path}
                      linkElement={Link}
                      selected={activeTab === tabValue}
                    >
                      {menuItem.title}
                    </TabLink>
                  </Tab>
                );
              })}
            </TabList>
          </Box>
        </div>
      </Tabs>
    </Main>
  </div>
);
